<template lang="html">
  <div id="login">
    <div class="row">
      <div class="col-lg-3"></div>
      <div class="col-lg-9">
        <RegLoginHeader/>
      </div>
      <div class="col-sm-12">
        <div class="row">
          <div class="col-lg-12 col-lg-3"></div>
          <div class="col-lg-12 col-lg-6">
            <h1 class="text-center">{{translation.registration.titleLogin}}</h1>
            <b-card no-body>
              <b-tabs card>
                <b-tab :title="translation.registration.user" active>
                  <b-card-text>
                    <UserLogin />
                  </b-card-text>
                </b-tab>
                <b-tab :title="translation.registration.doctor">
                  <b-card-text>
                    <DoctorLogin />
                  </b-card-text>
                </b-tab>
              </b-tabs>
            </b-card>
          </div>
          <div class="col-lg-12 col-lg-3"></div>
        </div>
      </div>

    </div>
    <div class="row">
      <div class="col-lg-12">
        <Footer/>
      </div>
    </div>
    <Cookies/>
  </div>
</template>
<script>

import UserLogin from '../components/UserLogin.vue';
import DoctorLogin from '../components/DoctorLogin.vue';
import RegLoginHeader from '../components/RegLoginHeader.vue';
import Footer from '../components/Footer.vue';
import Cookies from '../components/Cookies.vue'
export default {
  data(){
    return {
      translation: message
    }
  },
  components: {
    UserLogin,
    DoctorLogin,
    RegLoginHeader,
    Footer,
    Cookies
  },
}
</script>

<style lang="css">
#login .form-group{
  position: relative;
  margin-top: 2em;
}
#login{
  background: #FFF;
  background-image: url('../assets/img/backgrounds/hedyr-login-refistration.jpg');
  background-repeat:no-repeat;
  position: relative;
}
@font-face {
  font-family: 'Montserrat-Black';
  src: url("../assets/fonts/Montserrat-Black.woff") format("woff");
  font-display: swap;
}
#login .blue-paw{
  position: absolute;
  left: 0;
  bottom: 0;
  width: 15%;
}
#login h1{
  margin-top: 1em;
  margin-bottom: 1em;
  color: #fff;
  font-family: 'Montserrat-Black';
}
#login .forgot-pass{
  font-size: 1em;
  text-align: left;
  margin-bottom: 1em;
}
#login .login-button{
  background: #FE7154;
  padding-left: 1.5em;
  padding-right: 1.5em;
  border: none;
  outline: none;
  border-radius: 5em;
  margin-top: 1em;
  margin-bottom: 1em;
}
#login .footer {
  margin-top: 13em;
  margin-left: 3em;
  color: #707070;
}
#login .footer .footer-menu a {
  color: #707070;
}
#login .footer .col-lg-7{
  text-align: center!important;
}
 #login input[type=text],
 #login input[type=password],
 #login input[type=email]
 {
  color: #707070!important;
  background: none!important;
  border: none!important;
  border-radius: 0!important;
  outline: none!important;
  border-bottom: 2px solid #707070!important;
  width: 100%;
  outline: none!important;
  box-shadow: none;
}
#login label {
  display: none;
}
#login input[type=text]:focus,
#login input[type=password]:focus,
#login input[type=email]:focus
{
  border-bottom: 2px solid #3057B0!important;
  outline:0px !important;
  -webkit-appearance:none;
  box-shadow: none !important;
}
#login input[type=text]:focus + label ,
#login input[type=password]:focus + label,
#login input[type=email]:focus + label
{
   display: block;
   position: absolute;
   bottom: 2em;
   color: #212121!important;
   font-size: 1em;
}

#login input[type=text]:focus::-webkit-input-placeholder,
#login input[type=password]:focus::-webkit-input-placeholder,
#login input[type=email]:focus::-webkit-input-placeholder
{
  color:transparent;
}
#login input[type=text]::-moz-placeholder
#login input[type=password]:focus::-moz-placeholder
#login input[type=email]:focus::-moz-placeholder {
  color:transparent;
}
#login input[type=text]:focus::-moz-placeholder
#login input[type=password]:focus::-moz-placeholder
#login input[type=email]:focus::-moz-placeholder {
   color:transparent;
 }
 #login input[type=text]:focus::-ms-input-placeholder
 #login input[type=password]:focus::-ms-input-placeholder
 #login input[type=email]:focus::-ms-input-placeholder {
  color:transparent;
}
.list-group-item{
  border: none;
  background: none;
  padding-left: 0;
  font-size: .8em;
}
#login .requiredField input{
  border-bottom: 2px solid #F82727!important;
}
#login .requiredField label{
  color: #F82727!important;
  opacity: 1;
}
#login .page {
  margin-top: 1em;
}
@font-face {
  font-family: 'Raleway-Medium';
  src: url("../assets/fonts/Raleway-Medium.woff") format("woff");
  font-display: swap;
}
#login {
  font-family: 'Raleway-Medium';
}
@font-face {
  font-family: 'Montserrat-Medium', sans-serif;
  src: url("../assets/fonts/Montserrat-Black.woff") format("woff");
  font-display: swap;
}
#login .tabs .nav-link{
  color: #131313;
}
#login .tabs .nav-link.active{
  color: #3057B0;
  font-family: 'Montserrat-Medium', sans-serif;
}
#login .show-pass img{
  width: 1em;
  position: absolute;
  right: 0;
  top: 0;
}
#login .show-pass img:hover{
  cursor: pointer;
}
#login  .user-icon img,
#login  .vet-icon img
 {
  width: 2em;
}
/* @media (min-width: 992px){
.col-lg-4 {
    -ms-flex: 0;
    -webkit-box-flex: 0;
    flex: 0;
    min-width: 100%!important;
  }
} */
</style>
